enum PageAreas {
  body = 'page-body',
  header = 'page-header',
  startSide = 'page-start-side',
  endSide = 'page-end-side',
}

export default PageAreas;
